// @ts-nocheck

export type TenantListIsEchoesLinked = typeof TenantListIsEchoesLinked[keyof typeof TenantListIsEchoesLinked];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantListIsEchoesLinked = {
  true: 'true',
  false: 'false',
} as const;
